// Module
var code = "<p class=\"text-nomral text-light-black\" [ngClass]=\"isRebrading ? 'text-regular' : 'text-light'\"> {{ 'Ο λογαριασμός σας κλειδώθηκε επιτυχώς! Αν επιθυμείτε να τον ανακτήσετε, μπορείτε να μας καλέσετε στο ' | translate }} <span class=\"text-medium\">{{ phone }}</span>. </p> ";
// Exports
module.exports = code;